import React from "react";
import ReactDom from "react-dom";
import App from "./App";
import "./index.scss";
import createGoogleAnalytics, {
    DataLayer,
    GoogleTackingContext
} from "./services/googleTagManagerTracker";
import pingWatchdog from "./services/watchDogPing";

declare const dataLayer: DataLayer;
declare const VERSION: string;
// tslint:disable-next-line:no-console
console.log(`Running web version of MachineApp, current version: ${VERSION}`);

const googleTackEvent = createGoogleAnalytics(dataLayer);

const Application = () => (
    <GoogleTackingContext.Provider value={googleTackEvent}>
        <App />
    </GoogleTackingContext.Provider>
);

const render = () =>
    ReactDom.render(<Application />, document.getElementById("root"));
render();
pingWatchdog();

if ((module as any).hot) {
    (module as any).hot.accept("./App", render);
}
